// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__1Gvqy","buttons":"SendReceipts_buttons__1pSpN","email":"SendReceipts_email__1bd6F","bookApptTitle":"SendReceipts_bookApptTitle__iQtP2"};